/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Complimentary_Account_ErrorInputs */

const fr_admin_complimentary_account_error = /** @type {(inputs: Admin_Complimentary_Account_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de mettre à jour le compte offert`)
};

/**

* @param {Admin_Complimentary_Account_ErrorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_complimentary_account_error = /** @type {((inputs?: Admin_Complimentary_Account_ErrorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Complimentary_Account_ErrorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_complimentary_account_error(inputs)
});